function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStyleComputedProperty } from './utils';
var __vue_script__ = {
  name: 'Step',
  inject: ['stepRoot'],
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      seq: -2,
      stepSize: 0,
      isLast: false
    };
  },
  computed: {
    rootPrefixCls: function rootPrefixCls() {
      return this.stepRoot.prefixCls;
    },
    prefixCls: function prefixCls() {
      return "".concat(this.rootPrefixCls, "-item");
    },
    iconPrefix: function iconPrefix() {
      return this.stepRoot.iconPrefix;
    },
    rootStatus: function rootStatus() {
      return this.stepRoot.status;
    },
    isSupportFlex: function isSupportFlex() {
      return this.stepRoot.isSupportFlex;
    },
    direction: function direction() {
      return this.stepRoot.direction;
    },
    progressDot: function progressDot() {
      return this.stepRoot.progressDot;
    },
    current: function current() {
      return this.stepRoot.normalizeCurrent;
    },
    status: function status() {
      var seq = this.seq,
          current = this.current,
          rootStatus = this.rootStatus;
      var s = 'wait';

      if (seq === current) {
        s = rootStatus;
      } else if (seq < current) {
        s = 'finish';
      }

      return s;
    },
    lastDescendantOffsetW: function lastDescendantOffsetW() {
      return this.stepRoot.lastDescendantOffsetW;
    },
    hasNextError: function hasNextError() {
      var rootStatus = this.rootStatus,
          seq = this.seq,
          current = this.current;
      return rootStatus === 'error' && current && seq === current - 1;
    },
    classes: function classes() {
      var _ref;

      var rootPrefixCls = this.rootPrefixCls,
          prefixCls = this.prefixCls,
          status = this.status,
          icon = this.icon,
          $slots = this.$slots,
          hasNextError = this.hasNextError;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(status), true), _defineProperty(_ref, "".concat(prefixCls, "-custom"), icon || $slots.icon), _defineProperty(_ref, "".concat(rootPrefixCls, "-next-error"), hasNextError), _ref;
    },
    itemStyle: function itemStyle() {
      var isSupportFlex = this.isSupportFlex,
          seq = this.seq,
          direction = this.direction,
          stepSize = this.stepSize,
          lastDescendantOffsetW = this.lastDescendantOffsetW,
          $el = this.$el;
      var lastStepIdx = stepSize - 1; // IE9不支持flex, 兼容IE9,

      if (!isSupportFlex && direction !== 'vertical' && seq !== lastStepIdx) {
        var offset = Math.round(lastDescendantOffsetW / lastStepIdx) + 1;
        var mr = parseInt(getStyleComputedProperty($el, 'margin-right'), 10);

        if (mr) {
          offset += mr;
        }

        return {
          width: "calc(".concat(100 / lastStepIdx, "% - ").concat(offset, "px)")
        };
      }

      return {};
    }
  },
  created: function created() {
    this.addToRoot();
  },
  updated: function updated() {
    if (this.isLast) {
      var w = this.$el.offsetWidth;

      if (w !== this.lastDescendantOffsetW) {
        this.updateRootLastDescendantOffsetW(w);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeFromRoot();
  },
  methods: {
    iconClasses: function iconClasses(slotIcon) {
      var _ref2;

      var rootPrefixCls = this.rootPrefixCls,
          iconPrefix = this.iconPrefix,
          icon = this.icon,
          status = this.status,
          progressDot = this.progressDot;
      return _ref2 = {}, _defineProperty(_ref2, "".concat(rootPrefixCls, "-icon"), true), _defineProperty(_ref2, iconPrefix, !progressDot && !slotIcon && (icon || status === 'finish' || status === 'error')), _defineProperty(_ref2, "".concat(iconPrefix, "-").concat(icon), !progressDot && !slotIcon && icon), _defineProperty(_ref2, "".concat(iconPrefix, "-ok"), !progressDot && !slotIcon && !icon && status === 'finish'), _defineProperty(_ref2, "".concat(iconPrefix, "-close"), !progressDot && !slotIcon && !icon && status === 'error'), _ref2;
    },
    addToRoot: function addToRoot() {
      this.stepRoot.addDescendant(this);
    },
    removeFromRoot: function removeFromRoot() {
      this.stepRoot.removeDescendant(this);
    },
    updateRootLastDescendantOffsetW: function updateRootLastDescendantOffsetW(width) {
      this.stepRoot.updateLastDescendantOffsetW(width);
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "step",
    class: _vm.classes,
    style: _vm.itemStyle
  }, [_c('div', {
    class: _vm.prefixCls + "-tail"
  }), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + "-icon"
  }, [_c('span', {
    class: _vm.iconClasses(_vm.$slots.icon)
  }, [_vm._t("icon", [_vm.progressDot ? _c('span', {
    class: _vm.rootPrefixCls + "-icon-dot"
  }) : !_vm.icon && _vm.status !== 'finish' && _vm.status !== 'error' ? _c('span', [_vm._v("\n          " + _vm._s(_vm.seq + 1) + "\n        ")]) : _vm._e()])], 2)]), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + "-content"
  }, [_c('div', {
    class: _vm.prefixCls + "-title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + "-description"
  }, [_vm._t("desc", [_vm._v(_vm._s(_vm.desc))])], 2)])]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "step.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);